import { cloneRoute } from '@/utils/vue';
export default class History {
    constructor(router) {
        this._router = router;
        this._lastUniqueRoute = null;
        this._currentRoute = null;
        this._tracking = true;
        this._registerTracking();
    }
    /**
     * Get current route.
     */
    get current() {
        return this._currentRoute;
    }
    /**
     * Get last unique route.
     */
    get lastUnique() {
        return this._lastUniqueRoute;
    }
    /**
     * Register route in history.
     */
    registerRoute(route) {
        var _a;
        if (route.name !== ((_a = this._currentRoute) === null || _a === void 0 ? void 0 : _a.name)) {
            this._lastUniqueRoute = this._currentRoute;
        }
    }
    /**
     * Reset history tracking to original state.
     */
    resetTracking() {
        this._tracking = true;
    }
    /**
     * Set current route.
     */
    setCurrent(route) {
        this._currentRoute = cloneRoute(route);
    }
    /**
     * Register route tracking.
     */
    _registerTracking() {
        this._router.afterEach(to => {
            if (!this.current) {
                this.setCurrent(to);
                return;
            }
            if (this._tracking) {
                this.registerRoute(to);
            }
            this.setCurrent(to);
        });
    }
}
